import { render, staticRenderFns } from "./CustomFieldModalTableView.vue?vue&type=template&id=0e56778f&scoped=true"
import script from "./CustomFieldModalTableView.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalTableView.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalTableView.vue?vue&type=style&index=0&id=0e56778f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56778f",
  null
  
)

export default component.exports